import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadComment, leadCommentsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const LEAD_COMMENT_MODULE = 'leadComment';

const searchModule = getSearchModule(leadCommentsManager);
const dataObjectModule = getDataObjectsModule<ILeadComment>(leadCommentsManager, 5);

const leadCommentModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(LEAD_COMMENT_MODULE, leadCommentModuleInstance);

export { LEAD_COMMENT_MODULE };
